import React from "react";
import type { ChatMessage } from "../domain/types";
import ToolCallIndicator from "./ToolCallIndicator";

interface Props {
  message: ChatMessage;
}

const MessageBubble: React.FC<Props> = ({ message }) => {
  const isUser = message.role === "user";

  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"} mb-3`}>
      <div
        className={`max-w-[85%] rounded-xl px-3 py-2 text-sm leading-relaxed ${
          isUser
            ? "bg-quantum-500 text-white rounded-br-sm"
            : "bg-surface-700 text-text-primary rounded-bl-sm"
        }`}
      >
        {!isUser && message.toolCalls && message.toolCalls.length > 0 && (
          <ToolCallIndicator toolCalls={message.toolCalls} />
        )}
        <div className="whitespace-pre-wrap break-words">{message.content}</div>
      </div>
    </div>
  );
};

export default MessageBubble;
